<template>
    <div id="reference_art" style="width:100%;float:left;">
    	<div class="row">
    		<div class="col-4 float-left">
    			<v-select v-model="type" placeholder="Select type of request to ref" :options="formOptions" value="value" label="label"></v-select>
    		</div>
            <div class="col-3 float-left" v-show="type === '' ? false : type.value === 'component' ? true : false">
                <v-select v-model="component_type" placeholder="Select Component Type" :options="componentTypes" value="value" label="label"></v-select>
            </div>
    		<div class="col-3 float-left">
    			<input type="text" class="form-control" v-model="refNumber" placeholder="Reference #..." />
    		</div>
    		<div class="col-2 float-left">
    			<a class="btn btn-info" @click="findRequest()">Find</a>
    		</div>
    	</div>
    	<div class="row" v-if="loading">
    		<center>
              <i class="fa fa-circle-o-notch fa-spin" style="font-size: 50px;margin-top:10px;"></i>
            </center>
    	</div>
    	<div class="row" v-if="refImages && !refNotFound">
    		<h3 style="width:100%;text-align:center;float:left;margin-top:15px;">Click on the image(s) you want to reference.</h3>
    		<!-- <div class="checkarea" style="width:100%;float:left;">
                <div class="col-md-4" style="padding:5px;" :style="image.selected ? 'background-color:#ccc;' : ''" @click="image.selected = !image.selected" v-for="image in refImages">
                    <label style="text-align:center;width:100%;">
                        <input
                        v-model="image.selected"
                        type="checkbox">
                    </label>
                    <span v-if="image.id" style="width:100%;float:left;">
                        <center>
                            <img :src="'https://server.paiworkflow.com' + image.url" height="50px">
                        </center>
                    </span>
                    <span style="width:100%;text-align:center;float:left;">{{image.label}}</span>
                </div>
            </div> -->
            <div style="width:100%;float:left;">
                <div v-for="image in refImages" class="col-4 float-left text-center" style="cursor:pointer;height:200px;" :style="image.selected ? 'background-color:#ccc;' : ''" @click="image.selected = !image.selected">
                    <img style="max-width:100%;max-height:100%;" :src="'https://server.paiworkflow.com' + image.url">
                </div>
            </div>
            <div v-show="!attached" class="col-md-12 float-left" style="text-align:center;margin-top:15px;">
            	<a class="btn btn-info" @click="submitImages()">Attach Image(s)</a>
            </div>
            <div v-show="attached" class="col-md-12 float-left" style="text-align:center;margin-top:15px;color:green;">
            	Images are attached and ready for submit!
            </div>

            <spacer />
    	</div>
    	<div class="row" v-if="refNotFound">
    		<h3 style="width:100%;text-align:center;">No Reference # found with that type.</h3>
    	</div>
    </div>
</template>
<script>
// import {findReference, imageUrl} from './../config'
var methods = {}

methods.findRequest = function () {
	this.loading = true
	this.refNotFound = false
	this.attached = false
	const postData = {
		type: this.type.value,
		number: this.refNumber,
        component_type: this.component_type
	}
	console.log(postData)
	axios.post(this.$apiAdress + '/api/flow/findReference?token=' + localStorage.getItem('api_token'), postData).then(response => {
		if (response.status === 200) {
			if (response.data !== 'no-task' && response.data !== 'no-ref') {
				this.data = response.data
				var that = this
				this.refImages = []
				this.data.forEach(function (image) {
					var obj = {
						selected: false,
						id: image.id,
						url: image.url,
						label: image.file_name
					}
					that.refImages.push(obj)
				})
			} else {
				this.refNotFound = true
			}
			this.loading = false
		}
	})
}

methods.submitImages = function () {
	var images = []
	this.refImages.forEach(function (image) {
		if (image.selected) {
			images.push(image.id)
		}
	})
    console.log(this.type)
	this.$emit('image-selected', images, this.refNumber, this.type.value)
	this.attached = true
}

export default {
    name: "ReferenceArt",
    data: function () {
    	return {
    		data: null,
    		loading: false,
    		type: '',
    		refNumber: '',
    		refImages: null,
    		attached: false,
    		refNotFound: false,
            component_type: '',
            componentTypes: [
                'PPAS',
                'PPBS',
                'PPBCS',
                'PPE',
                'PPH',
                'PPCH',
                'PPHI',
                'PPL',
                'PPLE',
                'PPP',
                'PPRB',
                'PPS',
                'PPSS',
                'PPSSS',
                'PPSM',
                'PPSN',
                'PPWE',
                'PPSL',
                'PPHT',
                'PPMP',
            ],
    		formOptions: [
    			{
    				value: 'artpack',
    				label: 'Artpack'
    			},
                {
                    value: 'component',
                    label: 'Component'
                },
                {
                    value: 'heat_seal',
                    label: 'Heat Seal'
                },
    			{
    				value: 'license',
    				label: 'License'
    			}
    			// {
    			// 	value: 'quick_turn',
    			// 	label: 'Quick Turn'
    			// },
    			// {
    			// 	value: 'import_sample',
    			// 	label: 'Import Sample'
    			// },
    			// {
    			// 	value: 'mass_merchant',
    			// 	label: 'Mass Merchant'
    			// },
    			// {
    			// 	value: 'heat_seal',
    			// 	label: 'Heat Seal'
    			// },
    			// {
    			// 	value: 'pad_print',
    			// 	label: 'Pad Print'
    			// },
    			// {
    			// 	value: 'component',
    			// 	label: 'Component'
    			// }
    		]
    	}
    },
    methods: methods,
    mounted: function() {

    },
    destroyed: function() {

    }
}
</script>
<style lang="scss" scoped>
.checkarea div {float:left;display:inline-block;}

.checkarea, .checkarea2 {
    input {
    width: 50px !important;
    height: 40px;
    margin-right: 8px !important;
    text-align: center;
    float: left;
    margin-top: -10px;
    }
    input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button { 
        -webkit-appearance: none; 
        margin: 0; 
    }
    label {
        margin: 10px 10px 10px 0px;
        img {
            width: 40px;
            float: left;
            margin: -3px 8px 0 0;
        }
    }
    .col-sm-4 {
        padding: 0 8px 8px 8px;
    }
}

.checkarea {
    label {
        margin: 10px 10px 10px 60px;
    }
}
.checkarea2 {
    label {
        margin: 10px 10px 10px 0px;
    }
}
</style>
